module.exports = __webpack_public_path__ + "static/media/enable-landline.bdd86550.svg";